namespace GeniuzPOS.Purchase {
    export namespace ListAppCnrtvService {
        export const baseUrl = 'Purchase/ListAppCnrtv';

        export declare function Create(request: Serenity.SaveRequest<ListAppCnrtvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ListAppCnrtvRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ListAppCnrtvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ListAppCnrtvRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/ListAppCnrtv/Create",
            Update = "Purchase/ListAppCnrtv/Update",
            Delete = "Purchase/ListAppCnrtv/Delete",
            Retrieve = "Purchase/ListAppCnrtv/Retrieve",
            List = "Purchase/ListAppCnrtv/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ListAppCnrtvService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
